import { uniqBy } from 'es-toolkit';
import type { SaversPartnerLocationsResponse } from './api';

export const normalizePartnerLocations = (list: SaversPartnerLocationsResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }

  const uniquePartnerLocations = uniqBy(list, ({ branchKey }) => branchKey);
  return uniquePartnerLocations.map((row) => ({
    label: row.branchDesc,
    value: row.branchKey,
  }));
};
